import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import Auth from "./layouts/Auth";
import Dashboard from "./layouts/Dashboard";

// Route Views
import Signin from "./views/auth/Signin";
import Signout from "./views/auth/Signout";
import Home from "./views/dashboard/Home";
import Profil from "./views/dashboard/Profil";

const routes = [
  {
    path: "/",
    exact: true,
    layout: Auth,
    component: () => <Redirect to="/signin" />,
  },
  {
    path: "/signin",
    exact: true,
    layout: Auth,
    component: Signin,
  },
  {
    path: "/signout",
    exact: true,
    layout: Auth,
    component: Signout,
  },
  {
    path: "/home",
    exact: true,
    layout: Dashboard,
    component: Home,
  },
  {
    path: "/profil",
    exact: true,
    layout: Dashboard,
    component: Profil,
  },
];

export default routes;
